import { EventSchema } from '../../interfaces/EventInterfaces'
import { EVENT_NAME as EN } from '../../constants/EventName'
import { getCommonVoucherParams } from './VoucherViewEventSchema'

export const VoucherClickedEventSchema = (): EventSchema => {
  return {
    eventName: EN.VOUCHER_CLICKED,
    params: getCommonVoucherParams(),
  }
}